import { APP_NAVIGATION, APPS, TOGGLE_MODAL_EVENT_NAME } from "./constants.js";
export const filterAppNavigation = (apps) => {
    const filteredNavigation = {};
    const appDefinitions = Object.values(APPS);
    Object.entries(APP_NAVIGATION).forEach(([sectionKey, items]) => {
        const filteredItems = items
            // Filter out apps from the definition that are not in the apps array
            .filter((item) => apps.includes(item))
            // Find the app definition for each item
            .map((item) => {
            return appDefinitions.find((app) => app.key === item);
        })
            // Remove undefined items
            .filter((item) => item !== undefined);
        if (filteredItems.length > 0) {
            filteredNavigation[sectionKey] = filteredItems;
        }
    });
    return filteredNavigation;
};
export const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
const highbondEnv = [
    "highbond.local",
    "highbond-gov",
    "highbond-gov2",
    "highbond-gov3",
    "highbond.mil",
    "highbond-mil-s1",
];
export const isRestrictedEnv = highbondEnv.some((env) => window.location.href.indexOf(env) > -1);
export const dispatchToggleModalEvent = (target, open, type, close) => {
    const event = new CustomEvent(TOGGLE_MODAL_EVENT_NAME, {
        bubbles: true,
        composed: true,
        detail: {
            open,
            type,
            close,
        },
    });
    target.dispatchEvent(event);
};
export const defineComponent = (name, icon) => {
    if (customElements.get(name)) {
        return;
    }
    customElements.define(name, icon);
};
